import { gql } from "@apollo/client";
import { TypeDefinitionAttributeFields } from "../fragments/typeDefinitionAttribute";

export const InstalledBaseEventListFilterTDAs = gql`
    query InstalledBaseEventListFilterTDAs (
        $typeDefinitionIndex: InstalledBaseEventTypeDefinitionIndex!,
        $options: InstalledBaseEventTypeDefinitionAttributeListOptionsInput
    ) {
        installedBaseEventList {
            typeDefinitionAttributeList (typeDefinitionIndex: $typeDefinitionIndex, options: $options) {
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
